import { useNavigate, useLocation } from 'react-router-dom';
import RoundedButton from './commons/RoundedButton';
import laschool from '../images/laschool-logo.svg';
import { useTranslation } from 'react-i18next';

function ErrorPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const queryParams = new URLSearchParams(location.search);
    const errorParam = queryParams.get('error');
    const errorCode = errorParam ? errorParam.split(' ').pop() : null;

    return (
        // add laschool logo on top of the page

        <div className="relative flex h-fit min-h-[100vh]  w-screen items-center overflow-hidden flex-col mt-20">
            <img
                className="relative w-[110px] cursor-pointer mb-10"
                src={laschool}
                alt="Logo"
                onClick={() => {
                    navigate('/');
                }}
            />
            {errorCode === '401' || errorCode === '403' ? (
                <h1 className="text-3xl font-semibold text-text-dark">
                    {t('school_unauthorized_title')} {errorCode}
                </h1>
            ) : (
                <h1 className="text-3xl font-semibold text-text-dark">{t('school_404_title')} </h1>
            )}

            {errorCode === '401' || errorCode === '403' ? (
                <p className="mt-4 text-md sm:text-md font-medium text-text-grey">{t('school_unauthorized_page')}</p>
            ) : (
                <p className="mt-4 text-md sm:text-md font-medium text-text-grey">{t('school_page_not_found')}</p>
            )}

            <RoundedButton
                className="mt-12"
                theme="indigo"
                label="Retourner à la page d'accueil"
                onClick={() => {
                    navigate('/');
                }}
            />
        </div>
    );
}

export default ErrorPage;
